import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahscontact',
  templateUrl: './asahscontact.component.html',
  styleUrls: ['./asahscontact.component.scss']
})
export class AsahscontactComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
